import React, { useState } from 'react';
import { getToken } from '../services/keycloak/authService';
import './MFAVerificationModal.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const MFAVerificationModal = ({ isOpen, onVerified, onCancel }) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (!verificationCode || verificationCode.length !== 6) {
      setError('Please enter a 6-digit verification code');
      return;
    }

    try {
      setLoading(true);
      setError('');

      const token = getToken();
      const response = await fetch(`${API_URL}/mfa/validate`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: verificationCode,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Verification failed');
      }

      // Store verification status in sessionStorage
      sessionStorage.setItem('mfa_verified', 'true');
      sessionStorage.setItem('mfa_verified_at', Date.now().toString());

      onVerified();
    } catch (err) {
      console.error('Error verifying MFA:', err);
      setError(err.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && verificationCode.length === 6) {
      handleVerify();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="mfa-verification-overlay">
      <div className="mfa-verification-content">
        <div className="mfa-verification-header">
          <div className="mfa-lock-icon">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <h2>Two-Factor Authentication</h2>
          <p>Enter the 6-digit code from your authenticator app</p>
        </div>

        <div className="mfa-verification-form">
          <input
            type="text"
            className="mfa-verification-input"
            placeholder="000000"
            maxLength="6"
            pattern="[0-9]*"
            value={verificationCode}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setVerificationCode(value);
              setError('');
            }}
            onKeyPress={handleKeyPress}
            autoFocus
            disabled={loading}
          />
        </div>

        {error && <div className="mfa-verification-error">{error}</div>}

        <button
          className="btn-verify"
          onClick={handleVerify}
          disabled={loading || verificationCode.length !== 6}
        >
          {loading ? 'Verifying...' : 'Verify'}
        </button>
      </div>
    </div>
  );
};

export default MFAVerificationModal;
